import { subscribeChannel, publishChannel } from './channelUtils';

export function sendDrivers(drivers) {
    
    publishChannel('drivers-sync', drivers);

}

export function sendDriverUpsert(driver) {
    
    publishChannel('driver-upsert', driver);

}

export function sendDriverRemove(driverId) {
    
    publishChannel('driver-remove', driverId);

}

export function sendDriversTrip(trips) {

    publishChannel('drivers-trip', trips);

}

export function sendDriversSelectedTrips(driversEmViagemSelecionados) {

    publishChannel('drivers-trip-selected', driversEmViagemSelecionados);

}

export function listenDrivers(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'drivers-sync' &&
            tipo !== 'driver-upsert' &&
            tipo !== 'driver-remove' &&
            tipo !== 'drivers-trip' &&
            tipo !== 'drivers-trip-selected'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}